// Text constants using proper sentence case throughout the app
// This file serves as a reference for text styling and capitalization

/**
 * IMPORTANT TEXT STYLE GUIDELINES
 *
 * Apps must use proper grammar throughout to ensure the best experience for merchants.
 * Follow these capitalization rules:
 *
 * Use sentence case (capitalize the first word only) for:
 * - Headings
 * - Subheadings
 * - Buttons
 * - Card titles
 * - Email subject lines
 *
 * Do: "Custom influencer"
 * Don't: "Custom Influencer"
 *
 * Special cases:
 * - Product/brand names should retain their original capitalization (e.g., "Lookbook")
 * - Acronyms should be capitalized (e.g., "AI")
 *
 * For more details, refer to the Polaris guidelines on grammar and mechanics.
 */

// AI Tools section
export const CREATE_CUSTOM_INFLUENCER = 'Create custom influencer';
export const ANIMATE_IMAGE = 'Animate image';
export const PRODUCT_TRY_ON = 'Product try on';
export const REPLACE_BACKGROUND = 'Replace background';
export const TEXT_TO_IMAGE = 'Generate image';
export const CHAT_TO_IMAGE = 'Chat image editor';
export const CUSTOM_MODEL = 'Generate fashion model';
export const CUSTOM_INFLUENCER = 'Create an influencer avatar';

// Video templates
export const PROMOTION_VIDEO = 'Promotion video';
export const PRODUCT_COMPARISON_VIDEO = 'Product comparison video';
export const PRODUCT_RELEASE_VIDEO = 'Product release video';
export const BRAND_REVIEW_VIDEO = 'Brand review video';
export const INFLUENCER_PRODUCT_VIDEO = 'Influencer product video';
export const PRODUCT_VOICE_OVER_VIDEO = 'Product voice-over video';
export const FOUNDER_VIDEO = 'Founder video';
export const BEAUTY_SHOT = 'Video creation wizard';

// Navigation items
export const VIDEO_TEMPLATES = 'Video Maker';
export const AI_TOOLS = 'Image Maker';
export const MAKE_WITH_CHAT = 'Make With Chat';
export const INFLUENCERS = 'Influencers';
export const CREATIONS = 'Library';
export const PUBLISH = 'Publisher';
export const INTEGRATIONS = 'Content Sources';
export const SETTINGS = 'Settings';
export const SOURCES = 'Sources';
export const LABS = 'Labs (Beta)';

// Avatar input options
export const VIDEO_AND_VOICE = 'Video & voice';
export const VOICE_ONLY = 'Voice only';
export const SHOW_ADVANCED_SETTINGS = 'Advanced settings';
export const SELECTED_INFLUENCER = 'Selected influencer';
export const HIDE_BUBBLE_AVATAR = 'Hide bubble influencer';

// Common form inputs
export const TARGET_AUDIENCE = 'Target audience';
export const MEDIA_LIST = 'Media list';
export const TEXT_OVERLAY = 'Text overlay';
export const PLATFORM = 'Platform';
export const PRODUCT = 'Product';
export const MUSIC = 'Music';
export const CAPTIONS = 'Captions';
export const AVATAR = 'Influencer';

// Error states
export const GENERATION_FAILED = 'Generation failed';
